var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookOpenSolid = function SvgBookOpenSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8274 4.22393C18.9246 4.33192 15.1426 4.72498 12.8078 6.15417C12.6467 6.25279 12.5554 6.42814 12.5554 6.61147V19.2461C12.5554 19.6471 12.9939 19.9006 13.3637 19.7145C15.7659 18.5054 19.2399 18.1756 20.9576 18.0853C21.5441 18.0544 22 17.5842 22 17.0207V5.28992C22.0003 4.67498 21.467 4.18782 20.8274 4.22393ZM11.1922 6.15417C8.85776 4.72498 5.07575 4.33227 3.17294 4.22393C2.53334 4.18782 2 4.67498 2 5.28992V17.021C2 17.5849 2.45591 18.0551 3.04238 18.0856C4.76081 18.1759 8.23657 18.5061 10.6387 19.7159C11.0074 19.9016 11.4446 19.6485 11.4446 19.2485V6.60522C11.4446 6.42154 11.3536 6.25313 11.1922 6.15417Z",
    fill: "#EC7963"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookOpenSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book_open_solid.d7e27358.svg";
export { ForwardRef as ReactComponent };